import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=53d5913e&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=53d5913e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d5913e",
  null
  
)

export default component.exports